<template>
<div id="SzafaDD">
  <div id="btnNav">
    <div v-if="wielkoscSzafy>0" id="btnEmptyField">
      {{$t('message.puste_pola')}}:
      <md-avatar style="width: 28px;min-width: 20px;height: 24px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right;margin-right: 4px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
        <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>
        <md-tooltip md-direction="right" class="tooltipShort">
          {{$t('message.dodanie_puste_pola')}}
        </md-tooltip>
      </md-avatar>
      <br>
      <button class="btn btn-info" style="font-size: 14px;" @click="add_empty_field(1)">1U</button>
      <button class="btn btn-info" style="font-size: 14px;" @click="add_empty_field(2)">2U</button>
    </div>

    <div id="btnViews">
      <span v-if="view === 'przod' || view === 'tyl'" style="width:100%; display: block;margin-top: 15px;">{{$t('message.miejsce')}}:</span>
      <p v-if="view === 'przod'" style="color: #959594;">
      {{$t('message.miejsce_urzadzenia')}}: {{zajeteMiejscePrzod}}<br>
      {{$t('message.miejsce_calosc')}}: {{zajeteTotalPrzod}}<br>
      {{$t('message.miejsce_wolne')}}: {{wolneMiejscePrzod}}
      </p>
      <p v-if="view === 'tyl'" style="color: #959594;">
      {{$t('message.miejsce_urzadzenia')}}: {{zajeteMiejsceTyl}}<br>
      {{$t('message.miejsce_calosc')}}: {{zajeteTotalTyl}}<br>
      {{$t('message.miejsce_wolne')}}: {{wolneMiejsceTyl}}
      </p>

      <span style="width:85px; display: block;">{{$t('message.widok')}}:
        <md-avatar style="width: 16px;min-width: 16px;height: 22px;position: relative;right: 0px;bottom: 0px;float: right;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right;margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
          </svg>
          <md-tooltip md-direction="right" class="tooltipShort">
            {{$t('message.glebokosc_urzadzen')}}
          </md-tooltip>
        </md-avatar>
      </span>
      <button id="btnView" @click="view = 'przod', lista = 'przod'" class="btn" :class="(view === 'przod' && !disabledView) ? 'active' : ''" :disabled="disabledView">{{$t('message.przod')}}</button>
      <button id="btnView" @click="view = 'tyl', lista = 'tyl'" class="btn" :class="(view === 'tyl' && !disabledView) ? 'active' : ''" :disabled="disabledView">{{$t('message.tyl')}}</button>
      <br>
      <span style="width:100%; display: block; margin-top:20px">{{$t('message.dodatkowe')}}:</span>
      <!-- <button id="btnView" @click="view = 'inne'" class="btn" :class="(view === 'inne' && !disabledView) ? 'active' : ''" :disabled="disabledView">inne</button> -->
    </div>
  </div>
  <!-- <div class="row"> -->
    <div id="szafa" v-show="view === 'przod'" v-if="wielkoscSzafy>0" :style="[{backgroundImage: 'url(https://lib.pulsar.pl/img/konfigurator/szafa/szafa_'+wielkoscSzafy+'.svg)'}]">
      <div class="otwory_montazowe">
        <span v-for="(pole, index) in Number(wielkoscSzafy)" :key="index" :data-id="Number(wielkoscSzafy) - index"
        :style="{top: (index * (pxU)) + 'px'}">
          {{wielkoscSzafy - (index)}}
        </span>
      </div>

      <draggable
        class="dragArea list-group"
        :list="szafaPrzod"
        ghost-class="hidden-ghost"
        drag-class="drag-ghost"
        group="people"
        @change="log"
        :style="[{height: (pxU * wielkoscSzafy) + 'px'}]"
      >
         <!-- @mouseover="hover = true" @mouseleave="hover = false"> -->

        <div class="list-group-item" v-for="(elPrzod, idPrzod) in szafaPrzod" :key="idPrzod"
        :style="[{height: elPrzod.height}, {backgroundImage: 'url(https://lib.pulsar.pl/img/konfigurator/front/'+((elPrzod.symbol) ? elPrzod.symbol.replace('/', ',') + '.png' : 'undefined.png')}]"
        @mouseover="mouseOver = idPrzod"
        @mouseleave="mouseOver = null">
        <!-- @dragstart='startDrag($event, elPrzod)'
        @drop='onDrop($event, 1)'> -->
          <span class="productCode">{{elPrzod.symbol}}</span>

          <div v-if="mouseOver === idPrzod && elPrzod.type !== 'empty'">
            <i class="fa fa-times close"
            @click="removeAt(idPrzod, elPrzod.nr, elPrzod.symbol, 'przod', elPrzod.wysokosc_montazowa)"
            style="font-size: 12px;color: red;line-height: 0px;position: absolute;right: -24px;top: -16px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
            </svg>
            </i>
            <i class="fa fa-times close"
            v-if="elPrzod && elPrzod.podzespoly"
            @click="showAkcesoria(elPrzod.symbol, elPrzod.nr)"
            style="font-size: 12px;color: #01da01;line-height: 0px;position: absolute;right: -48px;top: 0px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
              <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
            </svg>
            </i>
            <i class="fa fa-times close"
            v-if="elPrzod.symbol"
            @mouseover="mouseOverInfo = true"
            @mouseleave="mouseOverInfo = false"
            @click="showAkcesoria(elPrzod.symbol, elPrzod.nr)"
            style="font-size: 12px;color: #009fff;line-height: 0px;position: absolute;right: -24px;top: 12px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
            </svg>
            </i>
            <div v-if="mouseOverInfo"
            style="font-size: 12px;color: rgb(0, 159, 255);line-height: 0px;position: absolute;right: 12px;top: 50px;transform: scale(1.4);opacity: 0.8;width: 240px;padding: 2px;line-height: 15px;text-align: right;background: #f5fdfd;padding: 6px;">
              {{elPrzod.symbol}}<br>
              {{elPrzod.nazwa}}
            </div>
          </div>

        </div>
        <!-- <div class="list-group-item" v-for="idEmpty in emptyPlaceholdFront" :key="Number(szafaPrzod.length + idEmpty)" style="height: 18px" disabled: false>{{Number(szafaPrzod.length + idEmpty)}}</div> -->
      </draggable>
    </div>
    <!-- {{emptyPlaceholdFront}} -->

    <div id="szafa" v-show="view === 'tyl'" v-if="wielkoscSzafy>0" :style="[{backgroundImage: 'url(https://lib.pulsar.pl/img/konfigurator/szafa/szafa_'+wielkoscSzafy+'.svg)'}]">
      <div class="otwory_montazowe">
        <span v-for="(pole, index) in Number(wielkoscSzafy)" :key="index" :data-id="Number(wielkoscSzafy) - index"
        :style="{top: (index * (pxU)) + 'px'}">
          {{wielkoscSzafy - (index)}}
        </span>
      </div>

      <draggable
        class="dragArea list-group"
        :list="szafaTyl"
        group="people"
        @change="log"
        :style="[{height: (pxU * wielkoscSzafy) + 'px'}]"
      >

        <div class="list-group-item" v-for="(elTyl, idTyl) in szafaTyl" :key="idTyl"
        :style="[{height: elTyl.height}, {backgroundImage: 'url(https://lib.pulsar.pl/img/konfigurator/front/'+((elTyl.symbol) ? elTyl.symbol.replace('/', ',') + '.png' : 'undefined.png')}]"
        @mouseover="mouseOver = idTyl"
        @mouseleave="mouseOver = null">
        <!-- @dragstart='startDrag($event, elTyl)'
        @drop='onDrop($event, 1)'> -->
          <span class="productCode">{{elTyl.symbol}}</span>

          <div v-if="mouseOver === idTyl">
            <i class="fa fa-times close"
            @click="removeAt(idTyl, elTyl.nr, elTyl.symbol, 'tyl')"
            style="font-size: 12px;color: red;line-height: 0px;position: absolute;right: -24px;top: -16px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
            </svg>
            </i>
            <i class="fa fa-times close"
            v-if="elTyl && elTyl.podzespoly"
            @click="showAkcesoria(elTyl.symbol, elTyl.nr)"
            style="font-size: 12px;color: #01da01;line-height: 0px;position: absolute;right: -48px;top: 0px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
              <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
            </svg>
            </i>
            <i class="fa fa-times close"
            v-if="elTyl.symbol"
            @mouseover="mouseOverInfo = true"
            @mouseleave="mouseOverInfo = false"
            @click="showAkcesoria(elTyl.symbol, elTyl.nr)"
            style="font-size: 12px;color: #009fff;line-height: 0px;position: absolute;right: -24px;top: 12px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
            </svg>
            </i>
            <div v-if="mouseOverInfo"
            style="font-size: 12px;color: rgb(0, 159, 255);line-height: 0px;position: absolute;right: 12px;top: 50px;transform: scale(1.4);opacity: 0.8;width: 240px;padding: 2px;line-height: 15px;text-align: right;background: #f5fdfd;padding: 6px;">
              {{elTyl.symbol}}<br>
              {{elTyl.nazwa}}
            </div>
          </div>
        </div>
      </draggable>
    </div>
  <div id="szafaInne">
    <div class="list-group-item-inne" v-for="(elInne, idInne) in szafaInne" :key="idInne">
      <span style="width:40px">
        <img style="height: 35px;" :src="getImgUrl(elInne.symbol)">
      </span>
      <span>
        <input class="form-control form-control-sm" style="widyh:55px" v-on:input="dodanie_sztuk(inputInne, elInne.symbol)" type='number' min=1 max=99 v-model="inputInne[elInne.symbol]"/>
        <i class="fa fa-times close" @click="removeAt(idInne, elInne.nr, elInne.symbol, 'inne')" style="font-size: 12px;color: red;line-height: 0px;position: relative;right: -15px;top: -34px;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
          </svg>
        </i>
        <md-avatar style="width: 16px;min-width: 16px;height: 22px;position: relative;right: -73px;bottom: 15px;float: left;"
        v-if="elInne.symbol === 'RAWP'">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right;margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
          </svg>
          <md-tooltip md-direction="right" class="tooltipShort" v-html="$t('message.info_RAWP')"></md-tooltip>
        </md-avatar>
      </span>

    </div>
  </div>
  <button id="btnAdd" :disabled="disabledButton" class="btn btn-success" @click="dodanie_do_szafy()">+</button>

  <Podzespoly :showDialog='showPodzespoly' @clickClose="showPodzespoly = !showPodzespoly" :symbol="deviceSymbol" :nr="deviceNumber"/>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import rawDisplayer from './infra/rawDisplayer'
import { app } from '../mixins/app'

import Podzespoly from '../components/Dialogs/Podzespoly'

// let idGlobal = 8
export default {
  name: 'DragDrop',
  props: ['device'],
  mixins: [app],
  display: 'Custom Clone',
  order: 3,
  components: {
    draggable, Podzespoly, rawDisplayer
  },
  data () {
    return {
      view: 'przod',
      lista: 'przod',
      pxU: 18,
      showPodzespoly: false,
      deviceSymbol: '',
      deviceNumber: '',
      zajeteMiejscePrzod: 0,
      zajeteTotalPrzod: 0,
      wolneMiejscePrzod: 0,
      zajeteMiejsceTyl: 0,
      zajeteTotalTyl: 0,
      wolneMiejsceTyl: 0,
      indexPrzod: 0,
      indexTyl: 0,
      indexInne: 0,
      indexGlobal: 0,
      inputInne: {},
      szafaPrzod: [],
      szafaTyl: [],
      szafaInne: [],
      hover: false,
      mouseOver: null,
      mouseOverInfo: false,
      list1: [
        // {
        //   'symbol': 'ARAD2',
        //   'id': 32937,
        //   'szerokosc_montazowa': '19.0000',
        //   'glebokosc_montazowa': null,
        //   'wysokosc_montazowa': '2.0000',
        //   'szerkosc': '395.0000',
        //   'wysokosc': '70.0000',
        //   'glebokosc': '400.0000',
        //   'nazwa': 'Obudowa RACK 2U/400mm uniwersalna do szaf RACK 19″',
        //   'waga': '5.9500',
        //   'cena': '202.0000',
        //   'wyprzedaz': null,
        //   'poza': null,
        //   'podzespoly': 1,
        //   'view': 'przod',
        //   'nr': null,
        //   'order': null,
        //   'height': '36px !important',
        //   'handle': null,
        //   'places': ''
        // }
        {
          'cena': '202.0000',
          'glebokosc': '400.0000',
          'glebokosc_montazowa': null,
          'height': '36px !important',
          'id': 32937,
          'nazwa': 'Obudowa RACK 2U/400mm uniwersalna do szaf RACK 19″',
          'nr': 23,
          'order': 23,
          'podzespoly': 1,
          'poza': null,
          'symbol': 'ARAD2',
          'szerkosc': '395.0000',
          'szerokosc_montazowa': 2,
          'total': 202,
          'value': 1,
          'view': 'przod',
          'waga': '5.9500',
          'wyprzedaz': null,
          'wysokosc': '70.0000',
          'wysokosc_montazowa': '2.0000'
        }
      ]
    }
  },
  watch: {
    device: {
      handler: function (val) {
        this.addItem(val)
      },
      deep: true
    },
    wielkoscSzafy (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.cosik(newValue)
      }
    },
    loadFile (newValue) {
      // console.log(newValue)
      if (newValue) {
        this.szafaPrzod = JSON.parse(JSON.stringify(this.outputs.items_przod)) //  Object.assign([], this.outputs.szafa)
        this.szafaTyl = JSON.parse(JSON.stringify(this.outputs.items_tyl)) //  Object.assign([], this.outputs.szafa)
        this.szafaInne = JSON.parse(JSON.stringify(this.outputs.items_inne)) //  Object.assign([], this.outputs.szafa)
      }
    },
    'outputs.items_przod': {
      handler: function (val) {
        if (val.length === 0) {
          this.clearRackPrzod()
        } else {
          this.add_number_u('przod')
        }
      },
      deep: true
    },
    'outputs.items_tyl': {
      handler: function (val) {
        if (val.length === 0) {
          this.clearRackTyl()
        } else {
          this.add_number_u('tyl')
        }
      },
      deep: true
    }
    // wielkoscSzafy (newValue) {
    //   for (var i = 0; i < newValue; i++) {
    //     this.szafaPrzod.push({
    //       height: `18px !important`,
    //       type: 'empty'
    //     })
    //   }
    // }
  },
  computed: {
    ...mapGetters('app', ['outputs', 'loadFile']),
    ...mapGetters('products', ['ListaPodzespoly']),
    wielkoscSzafy () {
      return this.$options.filters.decimal(this.outputs.szafa.wysokosc_montazowa)
    },
    disabledButton () {
      return !((Object.keys(this.outputs.item).length > 0))
    },
    disabledView () {
      return !((this.wielkoscSzafy > 0))
    },
    emptyPlaceholdFront () {
      return this.wielkoscSzafy - this.zajeteMiejscePrzod
    }
  },
  methods: {
    cosik (u) {
      var item = {}
      console.log(u)
      for (var i = 0; i < u; i++) {
        item = {}
        this.indexPrzod++
        this.indexGlobal++
        item.view = this.view
        item.nr = this.indexGlobal
        item.order = this.indexPrzod
        item.height = (18 * 1) + `px !important`
        item.waga = 0
        item.cena = 0
        item.wysokosc_montazowa = 1
        item.type = 'empty'
        this.szafaPrzod.push(JSON.parse(JSON.stringify(item)))
        // this.szafaPrzod.reverse()
        this.$store.commit('app/ADD_ITEMS', [this.view, item])
      }
      this.sprawdz_zajmowane_miejsce()
    },
    handleChange () {
      // console.log('changed')
    },
    log: function (evt) {
      window.console.log(evt)
      if (evt.added) {
        console.log('dodanie do szafy')
        console.log(evt.added.element)
        if (Object.keys(evt.added.element).length > 0) {
          this.$store.commit('app/ADD_ITEM', evt.added.element)
          this.dodanie_do_szafy()
        }
      }
      if (evt.moved && evt.moved.element !== undefined) {
        if (this.view === 'przod') {
          this.$store.commit('app/CHANGE_ITEMS', [this.view, this.szafaPrzod])
        }
        if (this.view === 'tyl') {
          this.$store.commit('app/CHANGE_ITEMS', [this.view, this.szafaTyl])
        }
        // this.$store.commit('app/CHANGE_ITEMS', item)
        this.sprawdz_zajmowane_miejsce()
      }
    },
    clearRackPrzod () {
      this.szafaPrzod = []
    },
    clearRackTyl () {
      this.szafaTyl = []
    },
    removeAt (id, nr, symbol, lista, wysokosc = null) {
      if (lista === 'przod') {
        console.log(id, nr, symbol, lista, wysokosc)
        this.szafaPrzod.splice(id, 1)
        this.wypelnienie_pustymi_polami(nr, wysokosc)
        this.$store.commit('app/CHANGE_ITEMS', ['przod', this.szafaPrzod])
        this.$store.commit('app/REMOVE_OUTPUTS_PODZESPOLY', nr)
      }
      if (lista === 'tyl') {
        this.szafaTyl.splice(id, 1)
        this.$store.commit('app/CHANGE_ITEMS', ['tyl', this.szafaTyl])
        this.$store.commit('app/REMOVE_OUTPUTS_PODZESPOLY', nr)
      }
      if (lista === 'inne') {
        this.szafaInne.splice(id, 1)
        // this.inputInne.splice(id, 1)
        delete this.inputInne[symbol]
        this.$store.commit('app/CHANGE_ITEMS', ['inne', this.szafaInne])
      }
      // this.$store.commit('app/REMOVE_OUTPUTS_PODZESPOLY', nr)
      this.sprawdz_zajmowane_miejsce()
    },
    showAkcesoria (symbol, nr) {
      this.deviceNumber = nr
      this.deviceSymbol = symbol
      this.showPodzespoly = true
    },
    wypelnienie_pustymi_polami (nr, wysokosc) {
      for (var i = 0; i < wysokosc; i++) {
        var item = {}
        // this.indexPrzod++
        // this.indexGlobal++
        item.view = 'przod' // this.view
        item.nr = (nr + i)
        item.order = (nr + i)
        item.height = (18 * 1) + `px !important`
        item.waga = 0
        item.cena = 0
        item.wysokosc_montazowa = 1
        item.type = 'empty'
        this.szafaPrzod.push(JSON.parse(JSON.stringify(item)))
      }
    },
    sprawdz_zajmowane_miejsce () {
      var iloscUprzod = 0
      var iloscUprzodTotal = 0
      var iloscUtyl = 0
      var iloscUtylTotal = 0
      if (this.wielkoscSzafy && this.wielkoscSzafy > 0) {
        if (this.view === 'przod') {
          this.szafaPrzod.forEach(element => {
            if (!element.type) {
              iloscUprzod += Number(element.wysokosc_montazowa)
            }
            iloscUprzodTotal += Number(element.wysokosc_montazowa)
          })
          this.zajeteMiejscePrzod = iloscUprzod
          this.zajeteTotalPrzod = iloscUprzodTotal
          this.wolneMiejscePrzod = this.wielkoscSzafy - iloscUprzod
        }
        if (this.view === 'tyl') {
          this.szafaTyl.forEach(element => {
            if (!element.type) {
              iloscUtyl += Number(element.wysokosc_montazowa)
            }
            iloscUtylTotal += Number(element.wysokosc_montazowa)
          })
          this.zajeteMiejsceTyl = iloscUtyl
          this.zajeteTotalTyl = iloscUtylTotal
          this.wolneMiejsceTyl = this.wielkoscSzafy - iloscUtyl
        }
      }
      if (this.loadFile) {
        this.$store.commit('app/SET_LOAD_FILE', false)
      }
    },
    dodanie_do_szafy () {
      console.log(this.outputs.item)
      var item = this.outputs.item
      // this.check_empty(item.wysokosc_montazowa)

      // usun puste jesli są
      var deleteEmpty = item.wysokosc_montazowa
      var delEmpty = 0
      var empties = Object.values(this.szafaPrzod).filter(item => (item.type === 'empty'))
      if (empties.length > (deleteEmpty - 1)) {
        for (var j = 0; j < Object.values(this.szafaPrzod).length; j++) {
          if (Object.values(this.szafaPrzod)[j].type === 'empty') {
            this.szafaPrzod.splice(j, 1)
            this.$store.commit('app/CHANGE_ITEMS', ['przod', this.szafaPrzod])
            delEmpty++
            if (delEmpty === Number(deleteEmpty)) {
              break
            }
          }
        }
        this.sprawdz_zajmowane_miejsce()
      }

      var itemPoza = item.poza
      // var numerek = (this.szafaPrzod.length + this.szafaTyl.length + this.szafaInne.length) + 1
      // console.log(numerek)
      if (Object.keys(item).length > 0) {
        if (itemPoza) {
          var inArr = false
          // this.view = 'inne'
          this.lista = 'inne'
          Object.values(this.szafaInne).forEach(element => {
            if (element.symbol === item.symbol) {
              inArr = true
            }
          })
          // console.log(inArr)
          if (inArr === false) {
            this.indexGlobal++
            item.view = 'inne'
            item.value = 1
            item.nr = this.indexGlobal
            this.szafaInne.push(item)
            this.inputInne[item.symbol] = item.value
            // this.szafaInne.push({name: item.symbol, id: this.indexInne, iloscU: this.$options.filters.decimal(item.wysokosc_montazowa), height: `${this.$options.filters.decimal(item.wysokosc_montazowa) * this.pxU}px !important`})
            this.$store.commit('app/ADD_ITEMS', ['inne', item])
          }
        } else {
          this.lista = this.view
          // console.log('przod')
          if (this.view === 'przod') {
            var roznicaPrzod = this.wielkoscSzafy - this.zajeteTotalPrzod - this.$options.filters.decimal(item.wysokosc_montazowa)
            if (roznicaPrzod > -1) {
              this.indexPrzod++
              this.indexGlobal++
              item.view = 'przod'
              item.nr = this.indexGlobal
              item.order = this.indexPrzod
              item.height = `${this.$options.filters.decimal(item.wysokosc_montazowa) * this.pxU}px !important`
              // this.szafaPrzod.push(JSON.parse(JSON.stringify(item)))
              this.szafaPrzod.unshift(JSON.parse(JSON.stringify(item)))

              this.$store.commit('app/ADD_ITEMS', [this.view, item])
              if (['ARAD2', 'ARAD3', 'ARAD4', 'ARAD-S2', 'ARAD-S4'].indexOf(item.symbol) > -1) {
                var glebokoscSzafy = Number(this.outputs.szafa.glebokosc)
                // var aras = this.$store.dispatch('products/get_akcesorium', [this.$i18n.locale, 'ARAS' + glebokoscSzafy])
                this.$store.dispatch('products/get_akcesorium', [this.$i18n.locale, 'ARAS' + glebokoscSzafy]).then(response => {
                  // console.log(response)
                  response.value = 1
                  this.$store.commit('app/UPDATED_OUTPUTS_PODZESPOLY', [this.indexGlobal, response])
                })
              } else {
              }
            }
          }
          if (roznicaPrzod < 0) {
            this.$store.commit('app/SET_INFORMATION', ['brak_miejsca_przod', this.$i18n.messages[this.$i18n.locale].message['full_place_front']])
            // this.$store.commit('app/SET_INFORMATION', 'Brak miejsca w szafie z przodu')
          }

          if (this.view === 'tyl') {
            var roznicaTyl = this.wielkoscSzafy - this.zajeteTotalTyl - this.$options.filters.decimal(item.wysokosc_montazowa)
            if (roznicaTyl > -1) {
              this.indexTyl++
              this.indexGlobal++
              item.view = 'tyl'
              item.nr = this.indexGlobal
              item.order = this.indexTyl
              item.height = `${this.$options.filters.decimal(item.wysokosc_montazowa) * this.pxU}px !important`
              this.szafaTyl.push(JSON.parse(JSON.stringify(item)))
              this.$store.commit('app/ADD_ITEMS', [this.view, item])
            }
          }
          if (roznicaTyl < 0) {
            this.$store.commit('app/SET_INFORMATION', ['brak_miejsca_tyl', this.$i18n.messages[this.$i18n.locale].message['full_place_back']])
          }
        }
        this.sprawdz_zajmowane_miejsce()
      }
    },
    dodanie_sztuk (val, symbol) {
      // console.log(val)
      // console.log(symbol)
      this.inputInne = JSON.parse(JSON.stringify(val))
      // console.log(this.inputInne)
      // this.inputInne[symbol] = JSON.parse(JSON.stringify(val[symbol]))
      this.$store.commit('app/CHANGE_ITEMS_INNE', [symbol, val[symbol]])
      if (this.loadFile) {
        this.$store.commit('app/SET_LOAD_FILE', false)
      }
    },
    add_empty_field (u) {
      var item = {}
      if (this.view === 'tyl') {
        if (Number(this.zajeteTotalTyl + u) <= Number(this.wielkoscSzafy)) {
          this.indexTyl++
          this.indexGlobal++
          this.szafaTyl.push({
            height: (18 * u) + `px !important`,
            type: 'empty',
            view: this.view,
            nr: this.indexGlobal,
            order: this.indexTyl,
            waga: 0,
            cena: 0,
            wysokosc_montazowa: u
          })
          // this.$store.commit('app/ADD_ITEMS', [this.view, item])
          this.sprawdz_zajmowane_miejsce()
        }
      } else {
        if (Number(this.zajeteTotalPrzod + u) <= Number(this.wielkoscSzafy)) {
          item = {}
          this.indexPrzod++
          this.indexGlobal++
          item.view = this.view
          item.nr = this.indexGlobal
          item.order = this.indexPrzod
          item.height = (18 * u) + `px !important`
          item.waga = 0
          item.cena = 0
          item.wysokosc_montazowa = u
          item.type = 'empty'
          this.szafaPrzod.push(JSON.parse(JSON.stringify(item)))

          // this.szafaPrzod.reverse()

          this.$store.commit('app/ADD_ITEMS', [this.view, item])
          // this.indexPrzod++
          // this.indexGlobal++
          // item.view = 'przod'
          // item.nr = this.indexGlobal
          // item.order = this.indexPrzod
          // item.height = `${this.$options.filters.decimal(item.wysokosc_montazowa) * this.pxU}px !important`
          // this.szafaPrzod.push(JSON.parse(JSON.stringify(item)))

          this.sprawdz_zajmowane_miejsce()
        }
      }
    },
    add_number_u (view) {
      var index = this.wielkoscSzafy
      if (view === 'przod') {
        this.szafaPrzod.forEach(element => {
          element.handle = index
          element.places = this.zajmowane_u(index, element.wysokosc_montazowa)
          index -= element.wysokosc_montazowa
        })
      }
      if (view === 'tyl') {
        this.szafaTyl.forEach(element => {
          element.handle = index
          element.places = this.zajmowane_u(index, element.wysokosc_montazowa)
          index -= element.wysokosc_montazowa
        })
      }
      this.check_collision()
    },
    zajmowane_u (montowaneU, iloscU) {
      var str = ''
      for (var i = montowaneU; i > (Number(montowaneU) - Number(iloscU)); i--) {
        str += i
        if (i === Number(montowaneU) - Number(iloscU) + 1) {
        } else {
          str += ','
        }
      }
      return str
    },
    check_collision () {
      var frontPlaces = ''
      var backPlaces = ''
      this.szafaPrzod.forEach(element => {
        if (element.symbol) {
          frontPlaces += element.places + ','
        }
      })
      this.szafaTyl.forEach(element => {
        if (element.symbol) {
          backPlaces += element.places + ','
        }
      })
      var front = []
      if (frontPlaces.length > 0) {
        frontPlaces = frontPlaces.substring(0, frontPlaces.length - 1)
        front = frontPlaces.split(',')
      }
      var back = []
      if (backPlaces.length > 0) {
        backPlaces = backPlaces.substring(0, backPlaces.length - 1)
        back = backPlaces.split(',')
      }
      var intersectingColors = this.getArraysIntersection(front, back)
      if (intersectingColors.length > 0) {
        this.$store.commit('app/SET_INFORMATION', ['mozliwa_kolizja', this.$i18n.messages[this.$i18n.locale].message['collision']])
      } else {
        // this.$store.commit('app/SET_INFORMATION', ['mozliwa_kolizja', '', 0])
      }
    },

    //     full_place_front: 'Elöl a szekrényben nincs hely',
    // full_place_back: 'Hátul nincs hely a szekrényben',
    // collision: 'Lehetséges termékütközés - elöl / hátul - ellenőrizze a mélységet',
    check_empty (wm) {
      // var index = 0
      // this.szafaPrzod.forEach(element => {
      //   if (element.type === 'empty' && index < wm) {
      //     index++
      //   }
      // })
      // var newArray = JSON.parse(JSON.stringify(this.szafaPrzod))
      // console.log(this.szafaPrzod)
      // for (var i = 0; i < newArray.length; i++) {
      //   if (newArray[i].type === 'empty' && index < wm) {
      //     newArray.splice(i, 1)
      //     index++
      //   }
      // }
      // this.szafaPrzod = JSON.parse(JSON.stringify(newArray))
      // console.log(this.szafaPrzod)
      // console.log(wm)
      // console.log(index)
    },
    onStart: function (event) {
      // console.log('onStart')
      // console.log(event)
    },
    onSave: function (event) {
      // console.log('onSave')
      // console.log(event)
    },
    onMove: function (event) {
      // console.log('onMove')
      // console.log(event)
      // console.log(event.draggedRect)
    },
    onEnd: function (event) {
      // console.log('onEnd')
      // console.log(event)
      // console.log(event.originalEvent.clientY)
      // console.log(event.originalEvent.layerY)
      // console.log(event.originalEvent.screenY)
      // this.endPosition = event.originalEvent.layerY
      // clientY: 436 layerY: 356 screenY: 563
    },
    onAdd: function (evt) {
      // console.log(evt)
      // console.log(this.endPosition)
      // console.log(evt.item._underlying_vm_.position)
      // evt.item._underlying_vm_.position = this.endPosition
    },
    startDrag: (evt, item) => {
      // console.log('startDrag')
      // console.log(evt)
      // console.log(item)
      // evt.dataTransfer.dropEffect = 'move'
      // evt.dataTransfer.effectAllowed = 'move'
      // evt.dataTransfer.setData('itemID', item.id)
    },
    onDrop (evt, list) {
      // console.log('onDrop')
      // const itemID = evt.dataTransfer.getData('itemID')
      // const item = this.items.find(item => item.id == itemID)
      // item.list = list
    }
    // cloneDog ({id, name, iloscU}) {
    //   if ((this.zajeteMiejsce + iloscU) < 11) {
    //     return {
    //       id: idGlobal++,
    //       name: `${name}`,
    //       iloscU: `${iloscU}`,
    //       height: `${iloscU * 25}px !important`
    //     }
    //   }
    // },

  }
}
</script>
<style scoped>
.hidden-ghost {
     /* display: none; */
 }
.hidden-drag{
  display: none;
}
#btnEmptyField {
position: relative;
right: 0px;
padding: 0px;
text-align: left;
top: 0px;
}

div.list-group-item {
  line-height: 2px; cursor: pointer;
  padding:0px;
  margin-bottom:0px;
  background-color: rgba(250,250,250,0);
  border-bottom: 1px solid #eae8e8
}
div.list-group-item:hover {
  background-color: rgba(250,250,250,0);
}
.list-group-item-inne {
background: none;
padding: 2px;
border: 1px solid #ccc;
width: 150px;
}
.list-group-item-inne input {
background: #f4f4f4;
padding: 6px;
width: 70px;
}
.list-group-item-inne span {
width: 75px;
height: 35px;
display: inline-block;
}
#szafa {
  width:280px; height:800px;
  padding: 0px;
  margin-left: 170px; /*90*/
  transform: scale(0.8);
  /* background: #ccc; */
}
#urzadzenia {
  width:250px; margin-right: 20px;
}
div.list-group {
  height: 756px;
  width: 250px;
  position: relative;
  top: 22px;
  left: 15px;
}
#btnAdd {
position: absolute;
right: 10px;
padding: 5px;
font-size: 40px;
width: 50px;
height: 50px;
line-height: 10px;
background: #00c3ff;
border-radius: 4px;
color: white;
bottom: 10px;
cursor: pointer;
}
.btn-success {
  border: 1px solid #00c3ff
}
#btnAdd:hover {
/* color: black; */
    color: #00c3ff;
    background-color: #fff;
    border-color: #00c3ff;
}
#SzafaDD {
  position: relative;
  height: 725px;
}
#SzafaDD .row {
  margin-top: 50px
}
#SzafaDD #btnNav {
  position: absolute;
  width:135px;
  left:0px;
  text-align: left;
  top: 80px;

}
#szafaInne {
  position: absolute;
  top: 360px;
  left: 0px;
}
#btnView {
padding: 0px;
width: 70px;
text-align: left;
color: #959594;
padding-left: 6px !important;
}
#btnView:hover {
background: #fff !important;
color: #00c3ff !important;
}
.active {
background: #00c3ff !important;
color: white !important;
padding-left: 6px !important;
}
/* .active:hover {
background: #fff !important;
color: #00c3ff !important;
padding-left: 6px !important;
} */
.btn-check:focus + .btn, .btn:focus {
    outline: 0;
    box-shadow: none;
}
.productCode {
font-size: 8px;
color: white;
position: absolute;
top: 2px;
left: 100px;
}

.otwory_montazowe {
  width:15px;
  margin-bottom:0px;
  text-align: left;
  position: relative;
  top: 20px;
}
.otwory_montazowe span{
font-size: 10px;
position: absolute;
margin-left: -15px;
}
.tooltipShort {
font-size: 14px;
display: table;
padding: 10px;
}
  .example {
    min-height: 300px;
  }

  .demo-option {
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .select {
    margin: 0 6px;
    display: inline-flex;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/DragDrop.vue